export const supportPhone = "0480 039 299";
export const supportEmail = "support@agrinous.com.au";
